import { PropsWithChildren, memo, useRef } from 'react';
import { useWindowSize } from 'react-easyrocket';
import { motion, AnimatePresence } from 'framer-motion';
import { useModalContext } from 'src/hooks/useModalContext';
import { twMerge } from 'tailwind-merge';

function _MobileModalWrapper({
  children,
  className,
  containerClassName,
  isTransparentBg
}: PropsWithChildren<{
  onClose?: () => void;
  className?: string;
  containerClassName?: string;
  isTransparentBg?: boolean;
  showCross?: boolean;
}>) {
  const { openedModalName } = useModalContext<{
    onClose?: () => void;
  }>();
  const isEventActive = false;
  const { isMobileLayout, isLandscape } = useWindowSize();
  const contentRef = useRef<HTMLDivElement | null>(null);
  const isShowingBlur = isEventActive && openedModalName?.includes('EVENT');

  return (
    <AnimatePresence>
      <div
        data-role="blackBackgroundFullscreenPlaceholder"
        className={twMerge(
          'flex items-end justify-center left-0 top-0 fixed z-[900] w-screen h-full max-h-screen bg-m_shadow',
          isShowingBlur && 'bg-[rgba(0,0,0,0.6)] backdrop-blur-[20px]'
        )}>
        <motion.div
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%' }}
          transition={{ type: 'tween', duration: 0.3 }}
          className={twMerge(
            'flex flex-col items-end w-full max-h-[90%] overflow-y-hidden',
            isLandscape && isMobileLayout && 'flex-row-reverse items-start h-full',
            className
          )}>
          <div
            ref={contentRef}
            key="modalMobileContentWrapper"
            data-role="modalMobileContentWrapper"
            className={twMerge(
              'modal-wrapper max-h-full w-full h-auto overflow-y-auto overflow-x-hidden rounded-[20px] self-end',
              !isTransparentBg ? 'bg-lm_bg shadow-xl' : 'bg-opacity-0',
              containerClassName
            )}>
            {children}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}

export const MobileModalWrapper = memo(_MobileModalWrapper);
